
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioSummaryDetailsProps } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';

@Component({
  components: {
    Heading,
    BaseText
  }
})
export default class StrategyDetail extends Vue {
  readonly nebraska = NebraskaColors;

  @Prop({ type: Object, required: true })
  readonly detailProps!: {
    managementType: IPortfolioSummaryDetailsProps;
  };
}
